import { HELPER_TRANSLATIONS, LABEL_TRANSLATIONS } from '../../../translations';
import { formatPerformanceChartData } from './helpers';

/*******************************
 *
 * Generate performance analysis chart node
 * @param {String} performanceTitle of the performance analysis chart
 * @param {Array} performanceChartData performance analysis chart data from analysis/performance
 * @returns {Object} pigeondoc chart node
 *
 ******************************/
const performanceSimpleScoreChart = (
  performanceTitle,
  performanceChartData,
  lang,
  threshold,
  chartType,
  alternative_x,
  alternative_y,
  alternative_x_hover,
  alternative_y_hover,
  add_suffix,
  performanceMode,
  performanceSentimentMode,
  minimalMode,
) => {
  const chartData = formatPerformanceChartData(
    performanceChartData,
    threshold,
    performanceSentimentMode,
    performanceMode,
  );

  if (minimalMode) {
    let thisChartType = 'horizontalBarChart';
    if (chartType == 'VerticalBarChart') {
      thisChartType = 'verticalBarChart';
    } else if (chartType == 'HorizontalBarChart') {
      thisChartType = 'horizontalBarChart';
    } else if (chartType == 'HorizontalLineChart') {
      thisChartType = 'horizontalLineChart';
    }

    const chart = {
      type: thisChartType,
      content: {
        title: '',
        data: chartData,
      },
      id: 'performance-chart',
      meta: {
        headingLevel: 'div',
        primaryBarColour: '#6A88AA',
        axisLabels: {
          x: '',
          y: '',
        },
        axisHoverText: {
          x: '',
        },
        suffix: '',
        scoreCutoff: threshold,
        minimalMode: true,
      },
    };
    if (performanceMode) {
      chart.meta.performanceMode = performanceMode;
    }
    return chart;
  } else {
    let newTitle = '';
    let newSuffix = '';
    if (add_suffix) {
      newSuffix = add_suffix;
    }

    if (performanceTitle == '') {
      newTitle = `<span class='performace-chart-title'>${HELPER_TRANSLATIONS.performanceTitle[lang]}</span>`;
    } else {
      newTitle = `<span class='performace-chart-title'>${performanceTitle}</span>`;
    }
    if (threshold > -1) {
      newTitle = newTitle + ' | % of those who scored above ' + threshold;
      newSuffix = '%';
    }

    // if segments, add sub-heading
    let thisChartType = 'horizontalBarChart';
    if (chartType == 'VerticalBarChart') {
      thisChartType = 'verticalBarChart';
    } else if (chartType == 'HorizontalBarChart' || chartType == 'horizontalBarChart') {
      thisChartType = 'horizontalBarChart';
    } else if (chartType == 'HorizontalLineChart' || chartType == 'horizontalLineChart') {
      thisChartType = 'horizontalLineChart';
    }

    let x_label = LABEL_TRANSLATIONS.performanceScore[lang];
    let y_label = LABEL_TRANSLATIONS.questions[lang];
    let axisHoverText = HELPER_TRANSLATIONS.performanceScoreAverage[lang];
    if (performanceMode == 'Volumes') {
      x_label = LABEL_TRANSLATIONS.volumes[lang];
      y_label = LABEL_TRANSLATIONS.questions[lang];
      axisHoverText = HELPER_TRANSLATIONS.performanceVolumesAverage[lang];
    }

    const chart = {
      type: thisChartType,
      content: {
        title: newTitle,
        data: chartData,
      },
      id: 'performance-chart',
      meta: {
        headingLevel: 'div',
        primaryBarColour: '#6A88AA',
        axisLabels: {
          x: x_label,
          y: y_label,
        },
        axisHoverText: {
          x: axisHoverText,
        },
        suffix: newSuffix,
        scoreCutoff: threshold,
      },
    };
    if (alternative_x) {
      if (LABEL_TRANSLATIONS[alternative_x]) {
        chart.meta.axisLabels.x = LABEL_TRANSLATIONS[alternative_x][lang];
      } else {
        chart.meta.axisLabels.x = alternative_x;
      }
    }
    if (alternative_y) {
      if (LABEL_TRANSLATIONS[alternative_y]) {
        chart.meta.axisLabels.y = LABEL_TRANSLATIONS[alternative_y][lang];
      } else {
        chart.meta.axisLabels.y = alternative_y;
      }
    }
    if (alternative_x_hover) {
      if (HELPER_TRANSLATIONS[alternative_x_hover]) {
        chart.meta.axisHoverText.x = HELPER_TRANSLATIONS[alternative_x_hover][lang];
      } else {
        chart.meta.axisHoverText.x = alternative_x_hover;
      }
    }
    if (alternative_y_hover) {
      if (HELPER_TRANSLATIONS[alternative_y_hover]) {
        chart.meta.axisHoverText.y = HELPER_TRANSLATIONS[alternative_y_hover][lang];
      } else {
        chart.meta.axisHoverText.y = alternative_y_hover;
      }
    }
    if (performanceMode) {
      chart.meta.performanceMode = performanceMode;
    }
    return chart;
  }
};

export { performanceSimpleScoreChart };
